module.exports = __webpack_public_path__ + "static/14-e9c49026c9ac9bf9d58dfbf05772138f.jpg";